export default __webpack_public_path__ + "static/globe-yellow-2283f10705a1754ba0981c4549663803.svg";